module.exports = __webpack_public_path__ + "static/4_2_recommendation_FR-5d8790fdfc98250fea52fb39b8298fcb.svg";